import React from "react";

type UserContextType = {
  isOpenAddActionDialog: boolean | null;
  setIsOpenAddActionDialog: React.Dispatch<React.SetStateAction<any>>;
  isOpenDeleteActionDialog: boolean | null;
  setIsOpenDeleteActionDialog: React.Dispatch<React.SetStateAction<any>>;
  isOpenViewActionDialog: boolean | null;
  setIsOpenViewActionDialog: React.Dispatch<React.SetStateAction<any>>;
  isOpenCopyActionDialog: boolean | null;
  setIsOpenCopyActionDialog: React.Dispatch<React.SetStateAction<any>>;
  isOpenCreatePlan: boolean | null;
  setIsOpenCreatePlan: React.Dispatch<React.SetStateAction<any>>;
  isOpenEditActionDialog: boolean | null;
  setIsOpenEditActionDialog: React.Dispatch<React.SetStateAction<any>>;
  isOpenAssigneeDialog: boolean | null;
  setIsOpenAssigneeDialog: React.Dispatch<React.SetStateAction<any>>;
  isOpenImportActionDialog: boolean | null;
  setIsOpenImportActionDialog: React.Dispatch<React.SetStateAction<any>>;
  isOpenPlanDetailDialog: boolean | null;
  setIsOpenPlanDetaiLDialog: React.Dispatch<React.SetStateAction<any>>;
};

// Creating the context object and passing the default values.
const ActionCardDialogsContext = React.createContext<UserContextType>({
  isOpenAddActionDialog: null,
  setIsOpenAddActionDialog: () => {},
  isOpenDeleteActionDialog: null,
  setIsOpenDeleteActionDialog: () => {},
  isOpenViewActionDialog: null,
  setIsOpenViewActionDialog: () => {},
  isOpenCreatePlan: null,
  setIsOpenCreatePlan: () => {},
  isOpenEditActionDialog: null,
  setIsOpenEditActionDialog: () => {},
  isOpenCopyActionDialog: null,
  setIsOpenCopyActionDialog: () => {},
  isOpenAssigneeDialog: null,
  setIsOpenAssigneeDialog: () => {},
  isOpenImportActionDialog: null,
  setIsOpenImportActionDialog: () => {},
  isOpenPlanDetailDialog: null,
  setIsOpenPlanDetaiLDialog: () => {}
});

export default ActionCardDialogsContext;
